import react, { useMemo } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const ResetPassword = () => {
    
    function useQuery() {
        const { search } = useLocation();

        return useMemo(() => new URLSearchParams(search), [search]);
    }

    let query = useQuery();

    if (!query.get("email") || !query.get("token")) {
        window.location.href = "/";
    }

    const handlePasswordReset = () => {
        const newPassword = document.querySelector('input[name="newPassword"]').value;
        const confirmPassword = document.querySelector('input[name="confirmPassword"]').value;

        if (!newPassword || !confirmPassword) {
            alert("Please fill in both password fields.");
            return;
        }

        if (newPassword !== confirmPassword) {
            alert("Passwords do not match. Please try again.");
            return;
        }

        // Here you would typically send the new password to the server to update it
        fetch(`${process.env.REACT_APP_API_URL}/guide/update-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ newPassword, email: query.get("email"), token: query.get("token") }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                window.location.href = "/?reset=success"; // Redirect to login page
            } else {
                alert("There was an error resetting your password. Please try again.");
            }
        })
        .catch(error => {
            alert("There was an error resetting your password. Please try again.");
        });
    }
    return (
        <>
            <Header />
            <section style={{marginTop: "20px", minHeight: "80vh"}}>
                <div style={{textAlign: "center", padding: "20px"}}>
                    <h1>Reset Password</h1>
                    <input type="password" name="newPassword" placeholder="Enter your new password" style={{fontSize: "24px", padding: "10px", width: "300px", textAlign: "center"}} /><br />
                    <input type="password" name="confirmPassword" placeholder="Confirm your new password" style={{fontSize: "24px", padding: "10px", width: "300px", textAlign: "center", marginTop: "10px"}} /><br />
                    <button onClick={handlePasswordReset} style={{backgroundColor: "#fe9628", color: "#fff", marginTop: "20px", padding: "10px 20px", fontSize: "24px", cursor: "pointer"}}>Reset Password</button>
                </div>
                <div style={{textAlign: "center", fontSize: "14px", color: "#666", marginBottom: "20px"}}>
                    <p>Remembered your password? <a href="/" style={{color: "#24afc2"}}>Back to Login</a></p>   
                </div>
            </section>
            <Footer />
        </>
    )
}

export default ResetPassword;